import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getDrugInteractions } from '../../store/selectors/prescriptionPad';
import { getUnit } from '../../store/utils';

const TYPE_STR: { [k: string]: string } = {
    x: 'Likely Drug Interaction',
    b: 'Likely Drug Interaction',
    c: 'Likely Drug Interaction',
    d: 'Likely Drug Interaction',
};

const LABEL_STYLE: { [k: string]: string } = {
    x: 'bg-orange-500',
    b: 'bg-orange-500',
    c: 'bg-orange-500',
    d: 'bg-orange-500',
};

const EXPAND_ICON = 'EXPAND_ICON';

const DrugInteractionExceptionPanel: React.FC = () => {
    const [isExpanded, setExpanded] = useState(false);

    const toggle = (): void => {
        document.getElementById(EXPAND_ICON)?.classList.toggle('rotate-180');
        setExpanded(!isExpanded);
    };

    const interactions = useSelector(getDrugInteractions);
    const validInteractions = interactions?.filter((i) => TYPE_STR?.[i?.type]);

    if (validInteractions.length === 0) {
        return null;
    }

    return (
        <div className="flex flex-col items-center  px-12 py-10 mx-4 border cursor-pointer border-status-warning bg-status-warningBG shadow-tight-1 rounded-4 space-y-10">
            <div onClick={toggle} className="flex items-center justify-between w-full select-none">
                <div className="flex items-center space-x-12">
                    <div className="flex items-center justify-center w-16 h-16">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                            className="fill-status-warning"
                            width="16"
                            height="16"
                        >
                            <path d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
                        </svg>
                    </div>
                    <p className="text-12 text-status-warning">
                        {validInteractions.length} Likely drug to drug interactions. Please note
                        that the following information is intended for reference purposes only. The
                        final decision rests solely with the healthcare provider.
                    </p>
                </div>
                <div
                    id={EXPAND_ICON}
                    className="transform-gpu transition-all duration-200 ease-in-out flex items-center justify-center w-16 h-16"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        width="12"
                        height="12"
                        className="cursor-pointer fill-status-warning"
                    >
                        <path d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z" />
                    </svg>
                </div>
            </div>
            {isExpanded &&
                validInteractions.map((i, index) => (
                    <div
                        key={index}
                        className="opacity-anim hover:bg-accent-6-15 flex items-center justify-between w-full p-8 mx-8 bg-accent-3-23 rounded-4 contraceptions"
                    >
                        <div className="grid xl:grid-cols-2 w-70p lg:grid-cols-1 gap-x-16 gap-y-8">
                            {i.drugs.map((drug) => {
                                return (
                                    <div className="">
                                        <p className="text-neutral-black text-12">{drug.name}</p>
                                        <p className="text-neutral-black text-9">{drug.generic}</p>
                                    </div>
                                );
                            })}
                        </div>
                        <div
                            className={`flex items-center px-8 py-2 space-x-6 ${
                                LABEL_STYLE[i.type]
                            } rounded-2`}
                        >
                            <div className="flex items-center justify-center w-16 h-16">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512"
                                    className="fill-white"
                                    width="14"
                                    height="14"
                                >
                                    <path d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
                                </svg>
                            </div>
                            <p className="leading-5 text-white text-12">{TYPE_STR[i.type]}</p>
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default DrugInteractionExceptionPanel;
